import { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import Button from "../../atoms/Button/Button";
import { submitAccessRequest } from "../../../services/formService";
import "./FormModal.css";

const initialFields = {
  organizationName: "",
  organizationType: "SDIS",
  email: "",
  phone: "",
  message: "",
};

const FormModal = ({ isOpen, onClose }) => {
  const [fields, setFields] = useState(initialFields);

  useEffect(() => {
    if (!isOpen) return;
    setFields(initialFields);
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSubmit = (event) => {
    event.preventDefault();
    submitAccessRequest(fields);
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={(event) => event.stopPropagation()}>
        <button className="modal-close" onClick={onClose} type="button" aria-label="Fermer">
          <CloseIcon fontSize="small" />
        </button>

        <h3 className="modal-title">Demander une démonstration gratuite</h3>
        <p className="modal-subtitle">
          SecuFire Action est gratuit pour les acteurs publics de la
          prévention et de la lutte contre les feux de forêt.
        </p>

        <form className="modal-form" onSubmit={handleSubmit}>
          <label className="modal-label">
            Nom de la structure
            <input
              type="text"
              required
              value={fields.organizationName}
              onChange={(event) => setFields({ ...fields, organizationName: event.target.value })}
            />
          </label>
          <label className="modal-label">
            Type de structure
            <select
              value={fields.organizationType}
              onChange={(event) => setFields({ ...fields, organizationType: event.target.value })}
            >
              <option value="SDIS">SDIS</option>
              <option value="Collectivité">Collectivité</option>
              <option value="Gestionnaire forestier">Gestionnaire forestier</option>
              <option value="Opérateur d'infrastructure sensible">Opérateur d'infrastructure sensible</option>
            </select>
          </label>
          <label className="modal-label">
            Email professionnel
            <input
              type="email"
              required
              value={fields.email}
              onChange={(event) => setFields({ ...fields, email: event.target.value })}
            />
          </label>
          <label className="modal-label">
            Téléphone
            <input
              type="tel"
              value={fields.phone}
              onChange={(event) => setFields({ ...fields, phone: event.target.value })}
            />
          </label>
          <label className="modal-label">
            Message
            <textarea
              rows={3}
              value={fields.message}
              onChange={(event) => setFields({ ...fields, message: event.target.value })}
            />
          </label>
          <Button label="Envoyer la demande" variant="dark" type="submit" fullWidth />
        </form>
      </div>
    </div>
  );
};

export default FormModal;
